import { useQuery } from 'react-query';
import { useMeter8000Data } from '../../../../features/meter/hooks/useMeter';
import minigridAPI from '../../../../features/minigrid/service/minigridAPI';
import { useAuth } from '../../../../features/auth/hooks';
import { findRegisteredMinigrid } from '../../../../features/minigrid/utils/installationCode';
import InstallationCodeLink from '../../../../features/minigrid/components/InstallationCode/InstallationCodeLink';

export interface InstallationCodeMiniPresenterProps {
  deviceId?: string;
  emptyLabel?: string;
}

// Code d'installation d'un compteur : celui du site inscrit que désigne son
// « Nom du minigrid » (même règle et mêmes requêtes en cache que la colonne
// Minigrid). Le compteur ne porte jamais de copie du code.
export default function InstallationCodeMiniPresenter({ deviceId, emptyLabel = '—' }: InstallationCodeMiniPresenterProps) {
  const { getMeterInfoLocalizationByMeterIdQuery } = useMeter8000Data(deviceId);
  const { getAccountIdUser } = useAuth();
  const accountId = getAccountIdUser();

  const allMinigridsQuery = useQuery({
    queryKey: ['allMinigridsByAccount', accountId],
    queryFn: () => minigridAPI.getAllMinigrids(0, 0, { accountId }),
    enabled: Boolean(accountId),
    staleTime: 5 * 60 * 1000,
  });

  if (getMeterInfoLocalizationByMeterIdQuery.isLoading || allMinigridsQuery.isLoading) {
    return <>...</>;
  }

  const site = findRegisteredMinigrid(
    allMinigridsQuery.data?.data,
    getMeterInfoLocalizationByMeterIdQuery.data?.minigridName,
  );
  return <InstallationCodeLink code={site?.minigrid_installation_code} emptyLabel={emptyLabel} />;
}
